export const linksConfig = {
  whatsapp: 'https://wa.me/+4915679400832',
  discord: 'https://discord.gg/47mTz77PvX',
  calEnterprise: 'https://go.felixvemmer.com/cal',
  twitter: 'https://x.com/BacklinkGPT',
  instagram: 'https://www.instagram.com/felixvemmer',
  linkedin: 'https://www.linkedin.com/company/102403184',
  affiliate: 'https://affiliate.backlinkgpt.com',
} as const

export type TLinksConfig = typeof linksConfig
